
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.55 9.2v5.6c0 .333.145.583.438.75.29.165.57.157.836-.027l4.403-2.824a.78.78 0 00.398-.699.78.78 0 00-.398-.7l-4.403-2.823c-.265-.184-.547-.192-.836-.028a.811.811 0 00-.437.75zM12 22a9.63 9.63 0 01-3.875-.79 10.123 10.123 0 01-3.188-2.148 10.123 10.123 0 01-2.148-3.187A9.63 9.63 0 012 12c0-1.367.262-2.66.79-3.875a10.123 10.123 0 012.147-3.188c.91-.91 1.973-1.625 3.188-2.148A9.63 9.63 0 0112 2a9.63 9.63 0 013.875.79 10.123 10.123 0 013.188 2.147c.91.91 1.625 1.973 2.148 3.188A9.63 9.63 0 0122 12a9.63 9.63 0 01-.79 3.875 10.123 10.123 0 01-2.148 3.188c-.91.91-1.972 1.625-3.187 2.148A9.63 9.63 0 0112 22zm0-10zm0 8.324c2.3 0 4.262-.812 5.887-2.437 1.625-1.625 2.437-3.586 2.437-5.887 0-2.3-.812-4.262-2.437-5.887C16.262 4.488 14.3 3.676 12 3.676c-2.3 0-4.262.812-5.887 2.437C4.488 7.738 3.676 9.7 3.676 12c0 2.3.812 4.262 2.437 5.887C7.738 19.512 9.7 20.324 12 20.324zm0 0"}})])
          )
        }
      }
    